import * as order from '../actions/add-order.actions';
import { AddOrderState } from '../add-order.state';

const initialState: AddOrderState = {
    orderForm: null,
    deliveryInfoForm: null,
    pickupInfoForm: null,
    products: [],
    documents: []
};

export const addOrderReducer = (state: AddOrderState = initialState,
                                action) => {
    switch (action.type) {
        case order.ActionTypes.UPDATE_ORDER_FORM:
            return {...state, orderForm: {...action.payload}};
        case order.ActionTypes.UPDATE_DELIVERY_INFO_FORM:
            return {...state, deliveryInfoForm: {...action.payload}};
        case order.ActionTypes.UPDATE_PICKUP_INFO_FORM:
            return {...state, pickupInfoForm: {...action.payload}};
        case order.ActionTypes.ADD_DOCUMENT:
            const addedDocumentList = [...state?.documents || []];
            addedDocumentList.push(action.payload);
            return {...state, documents: [...addedDocumentList]};
        case order.ActionTypes.UPDATE_DOCUMENT:
            let updatedDocumentList = [...state.documents || []];
            updatedDocumentList = updatedDocumentList.map(d => {
                if (d.id === action.payload.id) {
                    return {...d, ...action.payload.document};
                } else {
                    return d;
                }
            });
            return {...state, documents: [...updatedDocumentList]};
        case order.ActionTypes.DELETE_DOCUMENT:
            let deletedDocumentsList = [...state.documents || []];
            deletedDocumentsList = deletedDocumentsList.filter(l => l.id !== action.payload);
            return {...state, documents: [...deletedDocumentsList]};
        case order.ActionTypes.ADD_PRODUCT:
            const addedList = [...state?.products || []];
            addedList.push(action.payload);
            return {...state, products: [...addedList]};
        case order.ActionTypes.UPDATE_PRODUCT:
            const updatedList = [...state.products || []]
            updatedList[action.payload.index] = action.payload.product;
            return {...state, products: [...updatedList]};
        case order.ActionTypes.UPDATE_QUANTITY_FOR_PRODUCT:
            const updateListWithQuantities = [...state.products || []];
            const product = updateListWithQuantities[action.payload.index];
            updateListWithQuantities[action.payload.index] = {...product, quantity: action.payload.quantity};
            return {...state, products: [...updateListWithQuantities]};
        case order.ActionTypes.DELETE_PRODUCT:
            const deletedList = [...state.products || []];
            deletedList.splice(action.payload, 1)
            return {...state, products: [...deletedList]};
        case order.ActionTypes.CLEAR_ADD_ORDER:
            return {};
        default:
            return state;
    }
};
